module.exports = __webpack_public_path__ + "92f647f1c47e592d91a655a0c430398a.svg";